export const SYSTEM_EDITIONS = {
    BIZ_X_POS: "BIZ_X_POS",
    BIZ_X_POS_SMART: "BIZ_X_POS_SMART",
    BIZ_X_AUTO_CARE : "BIZ_X_AUTO_CARE"

}